import React, { type ReactNode } from 'react';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import type { AssetsLayout as AssetsLayoutType } from './index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyAssetsLayout = lazyForPaint<typeof AssetsLayoutType>(
	() =>
		import(/* webpackChunkName: "async-assets-layout" */ './index').then(
			(module) => module.AssetsLayout,
		),
	{ ssr: false },
);

export const AssetsLayout = ({ children }: { children: ReactNode }) => (
	<Placeholder name="assets-layout-async">
		<LazyAssetsLayout>{children}</LazyAssetsLayout>
	</Placeholder>
);
